import ApiService from './api.service';

export function index(params = {}) {
  return ApiService.query('organizations', params)
    .then((response) => {
      return response.data;
    });
}

export function show(id, params = {}) {
  return ApiService.get('organizations', id, params)
    .then((response) => {
      return response.data;
    });
}

export function create(params) {
  return ApiService.post('organizations', params, false)
    .then((response) => {
      return response.data;
    });
}

export function update(id, params) {
  return ApiService.update('organizations', id, params)
    .then((response) => {
      return response.data;
    });
}

export function destroy(id) {
  return ApiService.destroy(`organizations/${id}`);
}

export function exportHealthReport(id, params = {}) {
  return ApiService.query(`organizations/${id}/export_health_report`, params)
    .then((response) => {
      return response.data;
    });
}

export function alerts(id, params = {}) {
  return ApiService.query(`organizations/${id}/alerts`, params)
    .then((response) => {
      return response.data;
    });
}

export function exportActivityReport(id, params = {}) {
  return ApiService.query(`organizations/${id}/export_activity_report`, params)
    .then((response) => {
      return response.data;
    });
}

export function exportVaccineStatusReport(id, params = {}) {
  return ApiService.query(`organizations/${id}/export_vaccine_status_report`, params)
    .then((response) => {
      return response.data;
    });
}

export function groups(id, params = {}) {
  return ApiService.query(`organizations/${id}/groups`, params)
    .then((response) => {
      return response.data;
    });
}

export function users(id, params = {}) {
  return ApiService.query(`organizations/${id}/users`, params)
    .then((response) => {
      return response.data;
    });
}

export function members(id, params = {}) {
  return ApiService.query(`organizations/${id}/members`, params)
    .then((response) => {
      return response.data;
    });
}

export function activities(id, params = {}) {
  return ApiService.query(`organizations/${id}/activities`, params)
    .then((response) => {
      return response.data;
    });
}

export function publishedRiskResponsePlan(id, params = {}) {
  return ApiService.query(`organizations/${id}/published_risk_response_plan`, params)
    .then((response) => {
      return response.data;
    });
}

export function draftRiskResponsePlan(id, params = {}) {
  return ApiService.query(`organizations/${id}/draft_risk_response_plan`, params)
    .then((response) => {
      return response.data;
    });
}

export function healthActivity(id, params = {}) {
  return ApiService.query(`organizations/${id}/health_activity`, params)
    .then((response) => {
      return response.data;
    });
}

export function currentRiskStatus(id, params = {}) {
  return ApiService.query(`organizations/${id}/current_risk_status`, params)
    .then((response) => {
      return response.data;
    });
}

export function tags(id, scope = null, params = {}) {
  const modifiedParams = {...{scope: scope}, ...params};
  return ApiService.query(`organizations/${id}/tags`, modifiedParams)
    .then((response) => {
      return response.data;
    });
}

export default {
  index,
  show,
  create,
  update,
  destroy,
  exportHealthReport,
  exportActivityReport,
  exportVaccineStatusReport,
  groups,
  users,
  members,
  publishedRiskResponsePlan,
  draftRiskResponsePlan,
  activities,
  healthActivity,
  currentRiskStatus,
  tags,
  alerts
};
